<template>
    <DataviewHeader 
        :dtPost="templateData.data_view"
        :feTheme="feTheme"
        :templateData="templateData"
        @resetAll="filtersSubmit"
        @search="searchSubmit"
        />

    <DataviewFiltersComponent 
        :dtPost="templateData.data_view"
        :tableFiltersEnabled="templateData.enable_filters_bar"
        :tableFilters="templateData.table_filters" 
        :dateFilters="templateData.date_filter"
        :search="search"
        :vw="wrapperView"
        :feTheme="feTheme"
        :filtersPosition="templateData.filters_position"
        :softFilterArgument="softFilterArgument"
        @filtersSubmit="filtersSubmit"
        @filtersReset="filtersSubmit"
        />


    <DataviewTable
        :dtPost="data.data_view"
        :templateData="data"
        :feTheme="feTheme"
        :keyword="keyword"
        @sort="sortAction"
     />

</template>

<script lang="ts">

import { defineComponent } from 'vue'

import DataviewFiltersComponent from '@vueapp/components/dataviews/DataviewFiltersComponent.vue'
import DataviewHeader from '@vueapp/components/dataviews/DataviewHeader.vue'
import DataviewTable from '@vueapp/components/dataviews/DataviewTable.vue'

export default defineComponent({
    name: 'DataviewComponent',
    data() {
        return {
            count: 0,
            filters: {},
            sorting: {
                sortType: '',
                columnName: '',
                sortOrder: 'asc'
            },
            data: {},
            keyword: '',
            // isVw: '',
            // sort: true
        }
    },
    props: ['templateData', 'isViewWrapper'],
    components: { DataviewFiltersComponent, DataviewHeader, DataviewTable },
    emits: ['refresh'],
    computed: {
        feTheme() {
            return window.fe_theme 
        },
        search() {
            return this.templateData.search || []
        },
        softFilterArgument() {
            return this.templateData.soft_filter_argument ? this.templateData.soft_filter_argument : null
        }
    },

    inject: {
        wrapperView: {
            from: 'wrapperView',
            default: false
        }
    },

    created() {
        this.data = this.templateData

    },

    updated() {
        this.data.database_columns_data = this.templateData.database_columns_data
    },

    methods: {
        filtersSubmit(filters) {
            this.filters = filters //{ ...this.filters, ...filters }
            let sorting = this.sorting
            // this.refreshDataview()
            this.$emit('refresh', {filters: this.filters, sorting})
            this.emitter.emit('datatable-filter-applied')
        },

        searchSubmit( keyword ) {
            this.keyword = keyword
            this.emitter.emit('datatable-filter-applied')
        },

        toQueryString(obj, prefix) {
            var str = [], k, v;
            for(var p in obj) {
                if (!obj.hasOwnProperty(p)) {continue;} // skip things from the prototype
                if (~p.indexOf('[')) {
                    k = prefix ? prefix + "[" + p.substring(0, p.indexOf('[')) + "]" + p.substring(p.indexOf('[')) : p;
                    // only put whatever is before the bracket into new brackets; append the rest
                } else {
                    k = prefix ? prefix + "[" + p + "]" : p;
                }
                v = obj[p];
                str.push(typeof v == "object" ?
                  this.toQueryString(v, k) :
                  encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
            return str.join("&");
        },

        urldecode( url ) {
            return url
        },

        sortAction( evt ) {
            // this.sorting.columnName = evt.column.column_name
            // this.sorting.sortOrder = evt.column.sort.dir
            this.sorting = evt.sorting
            // this.refreshDataview()
            let filters = this.filters,
                sorting = this.sorting
            this.$emit('refresh', {filters, sorting})
        }
        
    }
})
</script>
